import * as index from './src/node/index.mjs';
export { index as node };
import * as index$1 from './src/utility/index.mjs';
export { index$1 as utility };
import * as index$2 from './src/dispose/index.mjs';
export { index$2 as dispose };
import * as index$3 from './src/animation/index.mjs';
export { index$3 as animations };

const register = {
  components: [],
  directives: [],
  use: (node2, type) => {
    switch (type) {
      case "component":
        register.components.push(node2);
        break;
      case "directive":
        register.directives.push(node2);
    }
    return node2;
  }
};

export { register };
//# sourceMappingURL=index.mjs.map
